import { Typography } from '@material-ui/core';
import { hasAdminAccess, SupplierId, SupplierProfile } from '@tripr/common';
import React from 'react';
import { useParams } from 'react-router-dom';
import { SupplierApi } from '../../api/RpcClient';
import { useAuthContext } from '../../utils/AuthContext';
import { useToast } from '../../utils/Utils';
import { LoadingGuard } from '../common/LoadingGuard';
import { SupplierProfileForm, SupplierProfileValues } from './SupplierProfileForm';

export const SupplierEditPage: React.FC = () => {
  const { supplierId } = useParams<{ supplierId: string }>();
  const [callWithToast] = useToast('supplier');
  const authContext = useAuthContext();

  if (!authContext.isLoggedIn || !hasAdminAccess(authContext.account.accountType)) {
    return null;
  }

  return (
    <LoadingGuard loadData={() => SupplierApi.getSupplier(SupplierId(supplierId))}>
      {supplier => (
        <div>
          <Typography gutterBottom variant="h2">
            Edit Supplier
          </Typography>
          <SupplierProfileForm
            supplier={supplier}
            onSubmit={async (values: SupplierProfileValues) => {
              const updatedSupplier = {
                supplierId: supplier.supplierId,
                ...values,
              } as SupplierProfile;

              await callWithToast(SupplierApi.updateSupplier(updatedSupplier));
            }}
          />
        </div>
      )}
    </LoadingGuard>
  );
};
